import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Spin,
  Icon,
  Modal,
  Button,
  Divider,
  Drawer,
  Form,
  // Select,
  message
} from 'antd';
import {
  ssrHandler,
  fetchMappedStatus,
  fetchUnmappedStatus,
  addNewStatus,
  updateUnmappedStatus,
  fetchWarehouse,
  putWarehouse
} from '../actions/sessionActions';
import Select, { createFilter } from 'react-select';

// const { Option } = Select;

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const columns = [
  {
    title: 'ID'
  },
  {
    title: 'Courier Partner'
  },
  {
    title: 'location'
  },
  {
    title: 'Action'
  }
];

const DescriptionItem = ({ title, content }) => (
  <div
    style={{
      fontSize: 14,
      lineHeight: '22px',
      marginBottom: 7,
      color: 'rgba(0,0,0,0.65)'
    }}
  >
    <p
      style={{
        marginRight: 8,
        display: 'inline-block',
        color: 'rgba(0,0,0,0.85)'
      }}
    >
      {title}:
    </p>
    {content}
  </div>
);

DescriptionItem.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string
};

export class StatusMapping extends Component {
  static async fetchData({ dispatch }, match, route) {
    await dispatch(ssrHandler(route.path));
  }

  constructor() {
    super();
    this.state = {
      visible: false,
      remarks: [],
      visibleDrawer: false,
      loading: false,
      idx: -1,
      selectedOption: []
    };
  }

  componentWillMount() {
    this.props.fetchWarehouse();
  }

  showDrawer = e => {
    this.setState({
      visibleDrawer: true,
      idx: Number(e.target.id)
    });
  };

  onClose = () => {
    this.setState({
      visibleDrawer: false,
      selectedOption: [],
      idx: -1,
      loading: false
    });
  };

  handleOk = () => {
    // this.setState({ loading: true });
    // const { idx, city } = this.state;
    // const { id } = this.props.statuses.unmapped.list[idx];
    // const query = { uber_status_code: city, id };
    // this.props.addNewStatus(query).then(res => {
    //   if (res.meta.success) {
    //     this.setState({
    //       loading: false,
    //       visibleDrawer: false,
    //       city: '',
    //       idx: -1
    //     });
    //     message.success('Your data has been successfully submitted.');
    //     const { list } = this.props.statuses.unmapped;
    //     list.splice(idx, 1);
    //     this.props.updateUnmappedStatus(list);
    //   } else {
    //     this.setState({ loading: false });
    //     message.error(res.meta.message);
    //   }
    // });
    const { idx, selectedOption } = this.state;
    const { unmapped } = this.props.warehouse;
    this.setState({ loading: true });
    this.props
      .putWarehouse({ id: unmapped[idx].id, city: selectedOption.value })
      .then(res => {
        if (res.meta.success) {
          this.props.fetchWarehouse();
          this.setState({
            loading: false,
            visibleDrawer: false,
            selectedOption: [],
            idx: -1
          });
          message.success('Your data has been successfully submitted.');
          this.setState({ loading: false });
        } else {
          this.setState({ loading: false });
          message.error(res.meta.message);
        }
      });
  };

  handleCancel = () => {
    this.setState({
      visible: false
    });
  };

  handleChange = selectedOption => {
    this.setState({ selectedOption });
  };

  render() {
    const { unmapped, isFetching, cities } = this.props.warehouse;
    const options = cities.map(item => ({
      value: item.city,
      label: item.city
    }));
    return (
      <div>
        <Row>
          <Col span={24}>
            {isFetching ? (
              <Spin indicator={antIcon} />
            ) : (
              <Fragment>
                {unmapped.length <= 0 ? (
                  <div>&nbsp; No Data</div>
                ) : (
                  <Fragment>
                    <table
                      className={`ant-table cm-table ant-table-small width-100pt`}
                    >
                      <thead className="ant-table-thead">
                        <tr>
                          {columns.map((item, i) => (
                            <th className="padding-8" key={i}>
                              {item.title}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="ant-table-tbody">
                        {unmapped.map((item, i) => (
                          <tr key={i}>
                            <td className="padding-8">{item.id}</td>
                            <td className="padding-8">
                              {item.courier_partner__name}
                            </td>
                            <td className="padding-8">{item.location}</td>
                            <td className="padding-8">
                              <Button
                                id={i}
                                type="primary"
                                size="small"
                                onClick={e => this.showDrawer(e)}
                              >
                                Update
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    <Drawer
                      title="New Warehouse Mapping"
                      width={'50%'}
                      closable={false}
                      onClose={this.onClose}
                      visible={this.state.visibleDrawer}
                    >
                      {this.state.idx > -1 ? (
                        <Fragment>
                          <Row>
                            <Col span={24}>
                              <DescriptionItem
                                title="ID"
                                content={unmapped[this.state.idx].id.toString()}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col span={24}>
                              <DescriptionItem
                                title="Courier Partner"
                                content={
                                  unmapped[this.state.idx].courier_partner__name
                                }
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col span={12}>
                              <DescriptionItem
                                title="Location"
                                content={unmapped[this.state.idx].location}
                              />
                            </Col>
                          </Row>
                          <Divider />
                          <Form layout="vertical" hideRequiredMark>
                            <Row gutter={16}>
                              <Col span={24}>
                                <Form.Item label="City">
                                  {/* <Select
                                    showSearch
                                    placeholder="Please choose the city"
                                    // optionFilterProp="children"
                                    // filterOption={(input, option) =>
                                    //   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    // }
                                    onChange={this.handleChange}
                                    value={
                                      this.state.city === ''
                                        ? 'Please choose the city'
                                        : this.state.city
                                    }
                                  >
                                    {cities.map((item, i) => (
                                      <Option
                                        key={i}
                                        value={item.city}
                                      >
                                        {item.city}
                                      </Option>
                                    ))}
                                  </Select> */}
                                  <Select
                                    filterOption={createFilter({
                                      ignoreAccents: false
                                    })}
                                    value={this.state.selectedOption}
                                    onChange={this.handleChange}
                                    options={options}
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                          </Form>
                        </Fragment>
                      ) : (
                        <Spin indicator={antIcon} />
                      )}
                      <div
                        style={{
                          position: 'absolute',
                          bottom: 0,
                          width: '100%',
                          borderTop: '1px solid #e8e8e8',
                          padding: '10px 16px',
                          textAlign: 'right',
                          left: 0,
                          background: '#fff',
                          borderRadius: '0 0 4px 4px'
                        }}
                      >
                        <Button
                          style={{
                            marginRight: 8
                          }}
                          onClick={this.onClose}
                        >
                          Cancel
                        </Button>
                        <Button
                          key="submit"
                          type="primary"
                          loading={this.state.loading}
                          onClick={this.handleOk}
                          disabled={this.state.city === '' ? true : false}
                        >
                          Submit
                        </Button>
                      </div>
                    </Drawer>
                  </Fragment>
                )}
              </Fragment>
            )}
          </Col>
        </Row>
        <Modal
          title="Remarks"
          visible={this.state.visible}
          onOk={this.handleCancel}
          onCancel={this.handleCancel}
        >
          <ul>
            {this.state.remarks.map((remark, i) => (
              <li key={i}>{remark}</li>
            ))}
          </ul>
        </Modal>
      </div>
    );
  }
}

StatusMapping.propTypes = {
  warehouse: PropTypes.object,
  config: PropTypes.object,
  match: PropTypes.object,
  addNewStatus: PropTypes.func,
  fetchMappedStatus: PropTypes.func,
  fetchUnmappedStatus: PropTypes.func,
  updateUnmappedStatus: PropTypes.func,
  fetchWarehouse: PropTypes.func,
  putWarehouse: PropTypes.func
};

StatusMapping.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  config: state.session.config,
  warehouse: state.session.warehouse
});

const mapDispatchToProps = dispatch => ({
  addNewStatus: query => dispatch(addNewStatus(query)),
  fetchMappedStatus: () => dispatch(fetchMappedStatus()),
  fetchUnmappedStatus: () => dispatch(fetchUnmappedStatus()),
  updateUnmappedStatus: list => dispatch(updateUnmappedStatus(list)),
  fetchWarehouse: () => dispatch(fetchWarehouse()),
  putWarehouse: (data, idx) => dispatch(putWarehouse(data, idx))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(StatusMapping)
);
